import Vue from 'vue';
import Component from 'vue-class-component';
import { MeetingService } from '@/services/meeting.service';
import { PRESENTATION_MODE_MEETING, _MEETINGS_STORE } from '@/meetings/values/meetings.values';
import keys from '@/values/keys';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { ScreenMirroringService } from '@/services/screen.mirroring.service';

@Component({})
export default class NavRedirectMixin extends Vue {

  get hasBackdrop() {
    let hasBackdrop = false;
    if(this.$route) {
      hasBackdrop = this.$route.fullPath.includes('tools');
    }
    return hasBackdrop;
  }

  get transparentBoardPath() : string {
    return this.$store.state.MeetingsStore.transparentBoardPath;
  }

  get mainMeetingType() : number {
    return this.$store.state.MeetingsStore.mainMeetingType;
  }

  get isTeacher(): boolean{
    return this.$store.state.AuthStore.role === keys.ROLES.PUBLISHER;
  }

  get isPresentationModeGuestTeacher() : boolean {
    return this.$store.state.MeetingsStore.isPresentationModeGuestTeacher;
  }

  goTo(pathName: string, params: any = {}, isInternal = false) {
    this.checkIfMeetingFinishAndContinue(isInternal, () => {
      this.emitScreenMirrorEvent(pathName, params);
      this.$router.push({ name: pathName, params }).catch(() => {});
    });
  }

  public emitScreenMirrorEvent(route: string, params: any = {}) {
    if(!this.isTeacher) {
      ScreenMirroringService.emitScreenMirroringEvent(
        this,
        {
          target: SCREEN_MIRRORING_EVENTS.GO_TO_PAGE,
          name: route,
          params
        },
      );
    }
  }

  public checkIfMeetingFinishAndContinue(isInternal: boolean, callback: any) {
    if(this.transparentBoardPath && this.mainMeetingType === PRESENTATION_MODE_MEETING && 
        !isInternal && this.isTeacher && !this.isPresentationModeGuestTeacher){
      this.teacherCloseMeetingConfirmation(() => callback());
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.SET_MAIN_MEETING_TYPE, 0);
    } else {
      callback();
    } 
  }

  public redirect(item, isInternal = false) {
    this.checkIfMeetingFinishAndContinue(isInternal, () => {
      if(item.router && this.$store.state.AppStore.usingRouter) {
        const data = { 
          name: item.route,
          params: item.params || {} 
        };
        if(!this.isTeacher) {
          ScreenMirroringService.emitScreenMirroringEvent(
            this,
            {
              target: SCREEN_MIRRORING_EVENTS.GO_TO_PAGE,
              ...data
            },
          );
        }
        this.$router.push(data).catch(() => {});
      } else {
        if(item.params) {
          const keys = Object.keys(item.params);
          if(keys.length > 0) {
            keys.forEach(k => {
              item.path = item.path.replace(`:${k}`, item.params[k]);
            });
          }
        }
        window.location.href = item.path;
      }
    });
  }

  private teacherCloseMeetingConfirmation(callback: any) {
    this.$EdModal.createConfirmationModal({
      title: this.$i18n.t('meetings.presentationMode.presentationMode'),
      body: this.$i18n.t('meetings.presentationMode.keepAllMarkups'),
      type: 'warning',
      actionText: this.$i18n.t('meetings.common.actionYes'),
      secondActionText: this.$i18n.t('meetings.common.actionNo'),
      action: () => {
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_TRANSPARENT_BOARD_PATH, '');
        callback();
      },
      secondAction: () => this.clearSessionAnotations(callback)
    });
  }

  private clearSessionAnotations(callback: any) {
    MeetingService.cleanMeetingBoardAnnotations(this.transparentBoardPath).finally(() => {
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_TRANSPARENT_BOARD_PATH, '');
      callback();
    });
  }

}